import script from "./KBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./KBadge.vue?vue&type=script&setup=true&lang=ts"

import "./KBadge.vue?vue&type=style&index=0&id=36da1435&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36da1435"]])

export default __exports__